<div class="container">
  <mat-form-field>
    <mat-label i18n>Number</mat-label>
    <input class="number-input" [(ngModel)]="dialNumber" autofocus matInput type="number" (keydown.enter)="goToNumber()">
  </mat-form-field>
  <mat-error *ngIf="error !== null" i18n>{{error}}</mat-error>

  <button mat-raised-button color="primary" class="number-button" (click)="goToNumber()" i18n>Go</button>
</div>
